"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var store_1 = require("../store");
var _1 = require("./");
var model_1 = require("../model");
var PrivateRoute_1 = require("../pages/_shared/components/PrivateRoute");
var moment = require("moment");
var constants_1 = require("../constants");
moment.locale(constants_1.DEFAULT_LANGUAGE);
// Listen for page changes to send them to do anything with them
// For example send to Google Analytics
store_1.history.listen(function (location, action) {
    // Example history usage
    // const hashLocation = window.location.hash.split("?")[0];
    // ReactGA = (Google Analytics)
    // ReactGA.set({ page: hashLocation });
    // ReactGA.pageview(hashLocation);
});
// Redirect to dashboard if authenticated, otherwise to login
var RootRedirectComponent = function (_a) {
    var authenticated = _a.authenticated;
    return (React.createElement(react_router_dom_1.Redirect, { to: authenticated ? '/dashboard' : '/login' }));
};
var RootRedirect = (0, react_redux_1.connect)(function (_a) {
    var reducer = _a.reducer;
    return ({
        authenticated: reducer.authentication.token !== null
    });
})(RootRedirectComponent);
var App = function () { return (React.createElement(react_router_dom_1.HashRouter, null,
    React.createElement(react_router_dom_1.Switch, null,
        React.createElement(react_router_dom_1.Route, { path: "/login", component: _1.LoginPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/map", permission: model_1.Permission.PAGE_REALTIME, component: _1.MapPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/dashboard", permission: model_1.Permission.PAGE_REALTIME, component: _1.MapPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/portal-users", permission: model_1.Permission.PAGE_PORTAL_USERS, component: _1.UserPortalManagment }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/app-users", permission: model_1.Permission.PAGE_APP_USERS, component: _1.UserAppManagment }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/gps-loss-users", permission: model_1.Permission.PAGE_GPS_LOSS_USERS, component: _1.GpsLossUsers }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/hour-control", permission: model_1.Permission.PAGE_HOURS, component: _1.HoursOverViewPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/hour-control-list/:ids/:day", permission: model_1.Permission.PAGE_HOURS, component: _1.UsersHourList }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/gps-proposal/:id?/:day?", component: _1.GpsProposalPage, permission: model_1.Permission.PAGE_HOURS }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/hour-control-user/:id/:day", permission: model_1.Permission.PAGE_HOURS, component: _1.UserHoursDetailPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/report", permission: model_1.Permission.PAGE_REPORTS, component: _1.ReportPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/report-hours", permission: model_1.Permission.PAGE_REPORT_HOURS, component: _1.ReportHoursPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/report-timelines", permission: model_1.Permission.PAGE_REPORT_TIMELINES, component: _1.ReportTimelinesPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/closing-day-report", permission: model_1.Permission.PAGE_CLOSING_DAY_REPORT, component: _1.ClosingDayPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/settings", permission: model_1.Permission.PAGE_SETTINGS, component: _1.SettingsPage }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: "/import-addresses", permission: model_1.Permission.IMPORT_ADDRESES, component: _1.ImportAddressesPage }),
        React.createElement(react_router_dom_1.Route, { path: "/notimplemented", component: _1.NotImplementedPage }),
        React.createElement(react_router_dom_1.Route, { path: "/500", component: _1.Page500 }),
        React.createElement(react_router_dom_1.Route, { exact: true, path: "/", component: RootRedirect }),
        React.createElement(react_router_dom_1.Redirect, { to: "/login" })))); };
exports.default = App;
